import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AppChangesDialogComponent } from '../../shared/app-changes-dialog/app-changes-dialog.component';
import { MarketingEditAndPreview } from './marketing-preview-edit.interface';

@Injectable()
export class MarketingPreviewAndEditGuard {
  constructor(public dialog: MatDialog) {}

  canDeactivate(
    component: MarketingEditAndPreview,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    currentRoute: ActivatedRouteSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    currentState: RouterStateSnapshot,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    nextState?: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (component.isPageEdited()) {
      const dialog = this.dialog.open(AppChangesDialogComponent, {
        width: '300px',
      });
      dialog.afterClosed().subscribe(() => {
        dialog.componentInstance.navigationEvent.unsubscribe();
      });
      return dialog.componentInstance.navigationEvent.pipe(
        map((message) => message === 'Navigate'),
        take(1),
      );
    } else {
      return true;
    }
  }
}
